// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2yB4F","vLegacy":"SelectSecondary_vLegacy__1lvP9","error":"SelectSecondary_error__1Pcmd","disabled":"SelectSecondary_disabled__2suR6"};